import { ChangeDetectionStrategy, Component, OnInit, signal, WritableSignal, inject, output } from '@angular/core';

import { MultiSelectChildOption } from './service-filter.model';
import { CategoriesApiService, TreatmentService } from '../../../../../api/products/categories/categories.service';
import { MultiSelectComponent } from '@ui-lib/components';

@Component({
    selector: 'service-filter',
    imports: [MultiSelectComponent],
    templateUrl: './service-filter.component.html',
    styleUrl: './service-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceFilterComponent implements OnInit {
  private categoriesApiService = inject(CategoriesApiService);

  readonly serviceSelectedChanged = output<TreatmentService[]>();

  servicesSelected: TreatmentService[] = [];
  multiSelectOptions: WritableSignal<MultiSelectChildOption[]> = signal([]);

  ngOnInit() {
    this.setMultiSelectOptions();
  }

  onSelectionEmitterEvent(event: MultiSelectChildOption[]) {
    this.servicesSelected = this.mapToTreatmentServices(event);
    this.serviceSelectedChanged.emit(this.servicesSelected);
  }

  private setMultiSelectOptions() {
    this.categoriesApiService.getCategories().subscribe(response => {
      const items: MultiSelectChildOption[] = response
        .flatMap(parentService => parentService.children || [parentService])
        .map(service => ({
          label: `${service.code} ${service.display_name}`,
          ...service,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : a.label < b.label ? -1 : 0));

      this.multiSelectOptions.set(items || []);
    });
  }

  private mapToTreatmentServices(selectedItems: MultiSelectChildOption[]): TreatmentService[] {
    return selectedItems.map(
      (option: MultiSelectChildOption) =>
        ({
          code: option.label.split(' ')[0],
          display_name: option.label.split(' ').slice(1).join(' '),
        } as TreatmentService),
    );
  }
}
